import { Status, type AsyncState } from '@essent/common';
import { createReducer, on } from '@ngrx/store';
import type { ScLinkField } from '@core/jss-models';

import {
  resetBoilerState,
  selectBoilerProductAction,
  submitAdviceForm,
  submitAdviceFormError,
  submitAdviceFormSuccess,
} from './boilers.actions';

export const boilersSelectorKey = 'eplus-boilers';

export interface BoilerProductData {
  title: string;
}
export interface BoilersState {
  selectedProduct: BoilerProductData | null;
  adviceFormSubmitStatus: AsyncState<void>;
  adviceFormRedirectUrl: ScLinkField | null;
}

export const initialState: BoilersState = {
  selectedProduct: null,
  adviceFormSubmitStatus: { status: Status.IDLE },
  adviceFormRedirectUrl: null,
};

export const boilersReducer = createReducer(
  initialState,
  on(selectBoilerProductAction, (state, { product }) => ({
    ...state,
    selectedProduct: {
      title: product.content.title,
    },
  })),
  on(submitAdviceForm, (state, params) => ({
    ...state,
    adviceFormSubmitStatus: { status: Status.PENDING },
    adviceFormRedirectUrl: params.onSuccessRedirectPage,
  })),
  on(submitAdviceFormSuccess, (state) => ({
    ...state,
    adviceFormSubmitStatus: { status: Status.IDLE },
  })),
  on(submitAdviceFormError, (state) => ({
    ...state,
    adviceFormSubmitStatus: { status: Status.ERROR },
  })),
  on(resetBoilerState, () => initialState)
);
